export const REGIONS = [
  {
    name: 'common:region.hokkaido',
    path: 'hokkaido',
    image: '/Hokkaido.jpeg',
    alt: 'common:region.hokkaido',
    title: 'common:region.hokkaido',
    mapCardTitle: 'common:region.hokkaido',
    lat: 43.064170000000004,
    lon: 141.34694,
    zoom: 7,
    prefectures: [
      {
        name: 'common:prefecture.hokkaido.hokkaido',
        path: 'hokkaido',
        lat: 43.064170000000004,
        lon: 141.34694,
        zoom: 7,
      },
    ],
  },
  {
    name: 'common:region.tohoku',
    path: 'tohoku',
    image: '/Tohoku.jpeg',
    alt: 'common:region.tohoku',
    title: 'common:region_title.tohoku',
    mapCardTitle: 'common:region_map_card_title.tohoku',
    lat: 37.75,
    lon: 140.46778,
    zoom: 7,
    prefectures: [
      {
        name: 'common:prefecture.tohoku.aomori',
        path: 'aomori',
        lat: 40.485056,
        lon: 140.93324,
        zoom: 11,
      },
      {
        name: 'common:prefecture.tohoku.iwate',
        path: 'iwate',
        lat: 39.119187,
        lon: 141.303371,
        zoom: 9,
      },
      {
        name: 'common:prefecture.tohoku.miyagi',
        path: 'miyagi',
        lat: 38.288165,
        lon: 140.819077,
        zoom: 9,
      },
      {
        name: 'common:prefecture.tohoku.akita',
        path: 'akita',
        lat: 39.769213,
        lon: 141.055909,
        zoom: 8,
      },
      {
        name: 'common:prefecture.tohoku.yamagata',
        path: 'yamagata',
        lat: 38.352808,
        lon: 140.356649,
        zoom: 9,
      },
      {
        name: 'common:prefecture.tohoku.fukushima',
        path: 'fukushima',
        lat: 37.366816,
        lon: 140.375131,
        zoom: 9,
      },
    ],
  },
  {
    name: 'common:region.kanto',
    path: 'kanto',
    image: '/Kanto.jpeg',
    alt: 'common:region.kanto',
    title: 'common:region_title.kanto',
    mapCardTitle: 'common:region_map_card_title.kanto',
    lat: 35.689440000000005,
    lon: 139.69167,
    zoom: 7,
    prefectures: [
      {
        name: 'common:prefecture.kanto.ibaraki',
        path: 'ibaraki',
        lat: 36.27086,
        lon: 140.44666999999998,
        zoom: 9,
      },
      {
        name: 'common:prefecture.kanto.tochigi',
        path: 'tochigi',
        lat: 36.729553,
        lon: 139.867384,
        zoom: 9,
      },
      {
        name: 'common:prefecture.kanto.gunma',
        path: 'gunma',
        lat: 36.484827,
        lon: 138.950537,
        zoom: 9,
      },
      {
        name: 'common:prefecture.kanto.saitama',
        path: 'saitama',
        lat: 35.868713,
        lon: 139.698211,
        zoom: 11,
      },
      {
        name: 'common:prefecture.kanto.chiba',
        path: 'chiba',
        lat: 35.548403,
        lon: 140.2176,
        zoom: 9,
      },
      {
        name: 'common:prefecture.kanto.tokyo',
        path: 'tokyo',
        lat: 35.704379,
        lon: 139.697494,
        zoom: 11,
      },
      {
        name: 'common:prefecture.kanto.kanagawa',
        path: 'kanagawa',
        lat: 35.441876,
        lon: 139.32979,
        zoom: 9,
      },
    ],
  },
  {
    name: 'common:region.chubu', // 中部 = 甲信越（新潟県, 山梨県, 長野県）+ 北陸（富山県, 石川県, 福井県）+ 東海（岐阜県, 静岡県, 愛知県, 三重県）
    path: 'chubu',
    image: '/Chubu.jpeg',
    alt: 'common:region.chubu',
    title: 'common:region_title.chubu',
    mapCardTitle: 'common:region_map_card_title.chubu',
    lat: 35.180279999999996,
    lon: 136.90667,
    zoom: 7,
    prefectures: [
      {
        name: 'common:prefecture.chubu.niigata',
        path: 'niigata',
        lat: 37.143565,
        lon: 138.593142,
        zoom: 9,
      },
      {
        name: 'common:prefecture.chubu.yamanashi',
        path: 'yamanashi',
        lat: 35.66389,
        lon: 138.593142,
        zoom: 9,
      },
      {
        name: 'common:prefecture.chubu.nagano',
        path: 'nagano',
        lat: 36.678997,
        lon: 138.117917,
        zoom: 10,
      },
      {
        name: 'common:prefecture.chubu.toyama',
        path: 'toyama',
        lat: 36.639624,
        lon: 137.113006,
        zoom: 10,
      },
      {
        name: 'common:prefecture.chubu.ishikawa',
        path: 'ishikawa',
        lat: 36.766563,
        lon: 137.000373,
        zoom: 9,
      },
      {
        name: 'common:prefecture.chubu.fukui',
        path: 'fukui',
        lat: 35.947725,
        lon: 136.189912,
        zoom: 12,
      },
      {
        name: 'common:prefecture.chubu.gifu',
        path: 'gifu',
        lat: 35.795261,
        lon: 137.174923,
        zoom: 8,
      },
      {
        name: 'common:prefecture.chubu.shizuoka',
        path: 'shizuoka',
        lat: 34.943609,
        lon: 138.322382,
        zoom: 8,
      },
      {
        name: 'common:prefecture.chubu.aichi',
        path: 'aichi',
        lat: 35.008643,
        lon: 137.209714,
        zoom: 8,
      },
      {
        name: 'common:prefecture.chubu.mie',
        path: 'mie',
        lat: 34.386622,
        lon: 136.494369,
        zoom: 8,
      },
    ],
  },
  {
    name: 'common:region.kansai',
    path: 'kinki',
    image: '/Kansai.jpeg',
    alt: 'common:region.kansai',
    title: 'common:region_title.kansai',
    mapCardTitle: 'common:region_map_card_title.kansai',
    lat: 34.68639,
    lon: 135.52,
    zoom: 7,
    prefectures: [
      {
        name: 'common:prefecture.kansai.shiga',
        path: 'shiga',
        lat: 35.178997,
        lon: 136.19958,
        zoom: 10,
      },
      {
        name: 'common:prefecture.kansai.kyoto',
        path: 'kyoto',
        lat: 34.992445,
        lon: 135.757572,
        zoom: 12,
      },
      {
        name: 'common:prefecture.kansai.osaka',
        path: 'osaka',
        lat: 34.629842,
        lon: 135.488437,
        zoom: 12,
      },
      {
        name: 'common:prefecture.kansai.hyogo',
        path: 'hyogo',
        lat: 35.038386,
        lon: 135.019682,
        zoom: 8,
      },
      {
        name: 'common:prefecture.kansai.nara',
        path: 'nara',
        lat: 34.68528,
        lon: 135.83278,
        zoom: 12,
      },
      {
        name: 'common:prefecture.kansai.wakayama',
        path: 'wakayama',
        lat: 33.905415,
        lon: 135.507471,
        zoom: 8,
      },
    ],
  },
  {
    name: 'common:region.chugoku',
    path: 'chugoku',
    image: '/Chugoku.jpeg',
    alt: 'common:region.chugoku',
    title: 'common:region_title.chugoku',
    mapCardTitle: 'common:region_map_card_title.chugoku',
    lat: 34.396390000000004,
    lon: 132.45944,
    zoom: 7,
    prefectures: [
      {
        name: 'common:prefecture.chugoku.tottori',
        path: 'tottori',
        lat: 35.410397,
        lon: 133.44601,
        zoom: 11,
      },
      {
        name: 'common:prefecture.chugoku.shimane',
        path: 'shimane',
        lat: 35.47222,
        lon: 133.05056000000002,
        zoom: 12,
      },
      {
        name: 'common:prefecture.chugoku.okayama',
        path: 'okayama',
        lat: 35.1994238,
        lon: 133.7226705,
        zoom: 11,
      },
      {
        name: 'common:prefecture.chugoku.hiroshima',
        path: 'hiroshima',
        lat: 34.573763,
        lon: 132.697142,
        zoom: 8,
      },
      {
        name: 'common:prefecture.chugoku.yamaguchi',
        path: 'yamaguchi',
        lat: 34.185829999999996,
        lon: 131.47138999999999,
        zoom: 9,
      },
    ],
  },
  {
    name: 'common:region.shikoku',
    path: 'shikoku',
    image: '/Shikoku.jpeg',
    alt: 'common:region.shikoku',
    title: 'common:region_title.shikoku',
    mapCardTitle: 'common:region_map_card_title.shikoku',
    lat: 33.55972,
    lon: 133.53111,
    zoom: 7,
    prefectures: [
      {
        name: 'common:prefecture.shikoku.tokushima',
        path: 'tokushima',
        lat: 34.06583,
        lon: 134.55944,
        zoom: 12,
      },
      {
        name: 'common:prefecture.shikoku.kagawa',
        path: 'kagawa',
        lat: 34.231484,
        lon: 133.865154,
        zoom: 9,
      },
      {
        name: 'common:prefecture.shikoku.ehime',
        path: 'ehime',
        lat: 33.84167,
        lon: 132.76611,
        zoom: 12,
      },
      {
        name: 'common:prefecture.shikoku.kochi',
        path: 'kochi',
        lat: 33.55972,
        lon: 133.53111,
        zoom: 12,
      },
    ],
  },
  {
    name: 'common:region.kyushu',
    path: 'kyushu',
    image: '/Kyushu.jpeg',
    alt: 'common:region.kyushu',
    title: 'common:region_title.kyushu',
    mapCardTitle: 'common:region_map_card_title.kyushu',
    lat: 33.606390000000005,
    lon: 130.41806,
    zoom: 7,
    prefectures: [
      {
        name: 'common:prefecture.kyushu.fukuoka',
        path: 'fukuoka',
        lat: 33.693611,
        lon: 130.684116,
        zoom: 9,
      },
      {
        name: 'common:prefecture.kyushu.saga',
        path: 'saga',
        lat: 33.24944,
        lon: 130.29889,
        zoom: 12,
      },
      {
        name: 'common:prefecture.kyushu.nagasaki',
        path: 'nagasaki',
        lat: 33.221434,
        lon: 129.602025,
        zoom: 10,
      },
      {
        name: 'common:prefecture.kyushu.kumamoto',
        path: 'kumamoto',
        lat: 32.601816,
        lon: 130.562892,
        zoom: 8,
      },
      {
        name: 'common:prefecture.kyushu.oita',
        path: 'oita',
        lat: 33.18561,
        lon: 131.49415,
        zoom: 10,
      },
      {
        name: 'common:prefecture.kyushu.miyazaki',
        path: 'miyazaki',
        lat: 31.811865,
        lon: 131.269378,
        zoom: 9,
      },
      {
        name: 'common:prefecture.kyushu.kagoshima',
        path: 'kagoshima',
        lat: 31.826172,
        lon: 130.377242,
        zoom: 9,
      },
    ],
  },
  {
    name: 'common:region.okinawa',
    path: 'okinawa',
    image: '/Okinawa.jpeg',
    alt: 'common:region.okinawa',
    title: 'common:region.okinawa',
    mapCardTitle: 'common:region.okinawa',
    lat: 25.370758,
    lon: 126.028712,
    zoom: 7,
    prefectures: [
      {
        name: 'common:prefecture.okinawa.okinawa',
        path: 'okinawa',
        lat: 25.370758,
        lon: 126.028712,
        zoom: 7,
      },
    ],
  },
];

export const PREFECTURES = REGIONS.reduce(
  (accumulator: { name: string; path: string }[], region) => {
    return accumulator.concat(region.prefectures);
  },
  []
);

export enum RegionEnum {
  'Hokkaido',
  'Tohoku',
  'Kanto',
  'Chubu',
  'Kansai',
  'Chugoku',
  'Shikoku',
  'Kyushu',
  'Okinawa',
}
